// extracted by mini-css-extract-plugin
export default {"button":"CartButton_button__Mm4M3","badge":"CartButton_badge__xzoxR"};